var $85eee97d14eef7b5$exports = {};
$85eee97d14eef7b5$exports = {
    "removeButtonLabel": `Fjern`,
    "removeDescription": `Trykk p\xe5 Slett for \xe5 fjerne taggen.`
};


export {$85eee97d14eef7b5$exports as default};
//# sourceMappingURL=nb-NO.module.js.map
